<template>
  <b-row>
    <b-card class="mb-2 col-12">
      <b-tabs>
        <b-tab
          v-for="tab in tabs"
          :key="tab.title"
          :title="tab.title"
          lazy
          @click.prevent="setActiveTabName(tab.mode)"
        >
          <b-col cols="12">
            <SearchFilter :mode="tab.mode" />
          </b-col>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-col
      v-for="tab in activeTab"
      :id="tab"
      :key="tab"
      cols="12"
    >
      <commonTable
        :mode="tab"
        @handleSend="getManageDetail"
        @handleGroup="getManageGroup"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BTabs, BTab, BButton, BCard, BCardHeader, BCardBody,
} from 'bootstrap-vue'
import commonTable from '../../table/vue-good-table/commonTableLawScreening.vue'
import SearchFilter from './components/SearchFilter.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    SearchFilter,
  },
  data() {
    return {
      tabs: [
        { title: 'รายการเรื่องร้องทุกข์', mode: 'List' },
        { title: 'เรื่องร้องทุกข์แบบเป็นกลุ่ม', mode: 'Group' },
      ],
      activeTab: ['List'],
    }
  },
  methods: {
    setActiveTabName(name) {
      this.activeTab = []
      this.activeTab.push(name)
    },
    getManageDetail(id) {
      const routeData = this.$router.resolve({ name: 'LawScreeningManage', query: { id } })
      window.open(routeData.href, '_blank')
    },
    getManageDetail(id) {
      const routeData = this.$router.resolve({ name: 'LawScreeningManage', query: { id } })
      window.open(routeData.href, '_blank')
    },
    getManageGroup(id) {
      const routeData = this.$router.resolve({ name: 'LawGroupdManage' })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

 <style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
